import Box from '@mui/material/Box';
import Grid from '@mui/material/GridLegacy';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

interface PropTypes {
  children: JSX.Element | JSX.Element[];
}

function SubSectionContainer(props: PropTypes): JSX.Element {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box>
      <Grid container spacing={4} direction={isMd ? 'row' : 'column'}>
        {props.children}
      </Grid>
    </Box>
  );
}

export default SubSectionContainer;
